<template>
	<div>
		<Header />
		<AboutUs />
		<Verse />
		<OurTeam />
		<Location />
		<Footer />
	</div>
</template>

<script>

import Header from './Header.vue'
import AboutUs from './AboutUs.vue'
import Verse from './Verse.vue'
import OurTeam from './OurTeam.vue'
import Location from '../../components/Location.vue'
import Footer from '../../components/Footer.vue'

export default {
	name: 'Index',
	components: { Header, AboutUs, Verse, OurTeam, Location, Footer },
	created: function() {
	}
}
</script>
